import { inject, Injectable } from '@angular/core';
import { BaseErrorInterceptor } from './base-error-interceptor';
import {
  ErrorInterceptorName,
  ErrorInterceptorNameValue
} from '@shared/interceptors/common/enum/error-interceptor-name';
import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ToastService } from '@shared/ui/kit/toast/toast.service';

@Injectable()
export class ErrorNotFoundInterceptor extends BaseErrorInterceptor {
  private readonly toastService: ToastService = inject(ToastService);

  readonly interceptorName: ErrorInterceptorNameValue = ErrorInterceptorName.errorNotFound;
  readonly httpStatusCode: HttpStatusCode = HttpStatusCode.NotFound as const;
  override errorCode: string | null = null;

  protected handleError(err: HttpErrorResponse): Observable<any> {
    this.toastService.error({
      title: "This didn't go right",
      message: this.getErrorMessageFromHttpErrorResponse(err)
    });
    return this.emptyResponse();
  }
}
